import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { COMPLETED_EVENT, ENVELOPE_EXPIRED } from './ContractSigning.const';

const SigningComplete = () => {
  const [searchParams] = useSearchParams();
  const eventParam = searchParams.get('event');

  useEffect(() => {
    if (window.parent) {
      if (eventParam === 'signing_complete')
        window.parent.postMessage({ message: COMPLETED_EVENT }, '*');
      else if (eventParam === 'ttl_expired')
        window.parent.postMessage({ message: ENVELOPE_EXPIRED }, '*');
    }
  }, [eventParam]);

  return <></>;
};

export default SigningComplete;
